import { render, staticRenderFns } from "./store_setup.vue?vue&type=template&id=319288a0&"
import script from "./store_setup.vue?vue&type=script&lang=js&"
export * from "./store_setup.vue?vue&type=script&lang=js&"
import style0 from "./store_setup.vue?vue&type=style&index=0&id=319288a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports